import {SimpleGrid, useDisclosure} from '@chakra-ui/react';
import {TitledSection} from 'components/layouts/aside-layout';
import {useCartContext} from 'components/providers';
import {ProductDetailsModal} from 'components/shared';
import {useTranslation} from 'hooks';
import {FC, useEffect, useState} from 'react';
import {hiddenScrollBarStyles} from 'theme';
import {ICartItem, IProduct} from 'types';

import {RecommendedProduct} from './RecommendedProduct';

interface Props {
  products: IProduct[];
  onItemClick: (product: IProduct, selectedOptions?: ICartItem) => void;
  title: string;
}

export const OrderRecommendationList: FC<Props> = ({title, products, onItemClick}) => {
  const {isOpen: isOpenProductModal, onOpen: onOpenProductModal, onClose: onCloseProductModal} = useDisclosure();
  const {t} = useTranslation();
  const [selectedProduct, setSelectedProduct] = useState<IProduct>();
  const {cartProvider} = useCartContext();

  useEffect(() => {
    if (selectedProduct) {
      onOpenProductModal();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedProduct]);

  const onClickRecommendedProduct = (product: IProduct) => {
    if (selectedProduct?.id === product.id) {
      onOpenProductModal();
    } else {
      setSelectedProduct(product);
    }
  };

  const handleAddProduct = (cart: ICartItem) => {
    if (selectedProduct) {
      onItemClick(selectedProduct, cart);
    }
  };

  if (!products?.length) return null;

  const wrapStyle = {
    '> div:last-child': {
      mr: ['15px', 0],
    },
    '> div:first-child': {
      ml: ['10px', 0],
    },
    ...hiddenScrollBarStyles,
  };

  return (
    <TitledSection title={title} h={['200px', 'auto']} position={['relative', 'static']}>
      <SimpleGrid
        ml={['-10px', 0]}
        columns={3}
        spacing="15px"
        position={['absolute', 'static']}
        minChildWidth={['auto', '250px']}
        w={['calc(100vw)', '100%']}
        gridAutoFlow={['column', 'unset']}
        overflowX={['scroll', 'unset']}
        sx={wrapStyle}
      >
        {products.map((product) => {
          return <RecommendedProduct key={product.id} product={product} onClick={onClickRecommendedProduct} />;
        })}
      </SimpleGrid>
      {isOpenProductModal && selectedProduct && (
        <ProductDetailsModal
          isOpen={isOpenProductModal}
          onClose={onCloseProductModal}
          product={selectedProduct}
          onAdd={handleAddProduct}
          t={t}
          providerSlug={cartProvider?.slug}
        />
      )}
    </TitledSection>
  );
};
